export class PlanoResponse {
    id: number;
    nome: string;
    preco: number;
    quantidadeUsuario: number;

    constructor(p: any) {
        this.id = p.id !== undefined ? p.id : null;
        this.nome = p.nome !== undefined ? p.nome : null;
        this.preco = p.preco !== undefined ? p.preco : 0;
        this.quantidadeUsuario = p.quantidadeUsuario !== undefined ? p.quantidadeUsuario : 0;
    }
}